"use client"

import type { CareerCenter } from "@/modules/careerCenter/types"
import type { I18nLocale } from "@/modules/i18n/types"
import type { CurrentUser } from "@/modules/user/api/types"
import type { FunctionComponent, MouseEventHandler } from "react"

import { useState } from "react"

import { Text } from "@jobteaser/spark/components/Text"

import { FeedbackButton } from "./FeedbackButton"

type InteractiveFeedbackProps = {
  className?: string
  currentUserCurriculumIds: CurrentUser["attributes"]["curriculumIds"]
  jobRoleId: string
  locale: I18nLocale
  negativeAnswerLabel: string
  positiveAnswerLabel: string
  schoolId: CareerCenter["id"]
  successMessage: string
  title: string
}

export const InteractiveFeedback: FunctionComponent<InteractiveFeedbackProps> = ({
  className,
  negativeAnswerLabel,
  positiveAnswerLabel,
  successMessage,
  title,
  ...props
}) => {
  const [submitted, setFeedbackSubmission] = useState(false)

  const handleClick: MouseEventHandler<HTMLButtonElement> = (): void => {
    setFeedbackSubmission(true)
  }

  return (
    <>
      <Text className={className} variant="body2">
        {submitted ? successMessage : title}
      </Text>

      {!submitted && (
        <>
          <FeedbackButton {...props} aria-label={positiveAnswerLabel} feedback="positive" onClick={handleClick} />
          <FeedbackButton {...props} aria-label={negativeAnswerLabel} feedback="negative" onClick={handleClick} />
        </>
      )}
    </>
  )
}
